module.exports = __webpack_public_path__ + "media/bg.2df179ac.mp4";